export class SumGroupStatus {
  group = {}
  total = 0
  constructor(data) {
    for (const item of data) {
      this.total += item.count_postagem_id

      if (!this.group[item.status_postagem_id]) {
        this.group[item.status_postagem_id] = 0
      }

      this.group[item.status_postagem_id] += item.count_postagem_id
    }
  }

  getAprovadas() {
    return this.group[2] || 0
  }

  getReprovadas() {
    return this.group[3] || 0
  }

  getTotal() {
    return this.total
  }
}
